import postRequest from '../../../../../../postRequest';

/**
 * Bulk upload a campaigns to multiple products.
 *
 * @param {{
 *  referenceIds: string[],
 *  productAttributeDefId: number,
 *  productAttributeLookupOptionId: number[],
 *  languageId: number,
 *  sourceId: number,
 *  siteId: number,
 *  siteGroupId: number
 * }}
 * @param {string[]} referenceIds Product Ids
 * @param {number} productAttributeDefId Attribute Id
 * @param {number[]} productAttributeLookupOptionId Lookup Option Id
 * @param {number} sourceId Source Id - Example, 1 for Shogun
 * @param {number} languageId Language Id
 * @param {number} siteId Site Id
 * @param {number} siteGroupId Id of the Site Group
*/
export default function postCampaignsPluId({
  referenceIds,
  productAttributeDefId,
  productAttributeLookupOptionId,
  languageId,
  sourceId,
  siteId,
  siteGroupId,
}) {
  const endpoint = `/oc-product-bulkapi/v1/bulk-process/campaigns/plu-id/${sourceId}`;

  const body = {
    referenceIds,
    productAttributeDefId,
    productAttributeLookupOptionId,
    languageId,
    siteId,
    siteGroupId,
  };

  return new Promise((resolve, reject) => {
    postRequest(endpoint, body, 'Campaigns (PLU)', 'Started : Campaigns : PLU (Update)')
      .then((response) => resolve(response))
      .catch((error) => reject(error));
  });
}
